// src/constants/phoneCodes.js
// Phone country codes for phone input component

export const countries = [
    { code: 'SA', label: 'Saudi Arabia', phone: '966' },
    { code: 'SD', label: 'Sudan', phone: '249' },
    { code: 'EG', label: 'Egypt', phone: '20' },
    { code: 'AE', label: 'United Arab Emirates', phone: '971' },
    { code: 'QA', label: 'Qatar', phone: '974' },
    { code: 'KW', label: 'Kuwait', phone: '965' },
    { code: 'BH', label: 'Bahrain', phone: '973' },
    { code: 'OM', label: 'Oman', phone: '968' },
    { code: 'JO', label: 'Jordan', phone: '962' },
    { code: 'IQ', label: 'Iraq', phone: '964' },
    { code: 'LB', label: 'Lebanon', phone: '961' },
    { code: 'SY', label: 'Syria', phone: '963' },
    { code: 'YE', label: 'Yemen', phone: '967' },
    { code: 'LY', label: 'Libya', phone: '218' },
    { code: 'TN', label: 'Tunisia', phone: '216' },
    { code: 'DZ', label: 'Algeria', phone: '213' },
    { code: 'MA', label: 'Morocco', phone: '212' },
    { code: 'TR', label: 'Turkey', phone: '90' },
    { code: 'PK', label: 'Pakistan', phone: '92' },
    { code: 'MY', label: 'Malaysia', phone: '60' },
    { code: 'ID', label: 'Indonesia', phone: '62' },
    { code: 'GB', label: 'United Kingdom', phone: '44' },
    { code: 'US', label: 'United States', phone: '1' },
];
